// app/faq.js

(function () {
    'use strict';
    var controllerId = 'faq';
    angular.module('app').controller(controllerId, ['$rootScope', 'common', 'bootstrap.dialog', '$filter', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', faq]);

    function faq($rootScope, common, bDialog, $filter, $routeParams, $uibModal, datacontext, sectionMenu) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard

        var vm = this;
        vm.title = 'Faq';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        //Gestione sola lettura
        vm.readOnly = !$rootScope.isAuthorized('SUPER');

        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.page = 1;
        vm.loading = false;
        vm.addDisabled = vm.readOnly;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;


        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }
    }
})();
